'use client';
import styled, { css } from 'styled-components';

export const NavLinkGroupHeading = styled.p`
  ${props => props.theme.fontFamily.base};
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.1em;
  margin-bottom: ${props => props.theme.spacing(-1)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
`;

export const StyledNavLinkGroup = styled.ul`
  text-align: left;
  min-width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(4)};
  ${props => props.theme.typography.heading5};
  ${props => props.theme.fontFamily.base};
  ${NavLinkGroupHeading} {
    margin-top: ${props => props.theme.spacing(8)};
  }
  font-size: 18px;
  font-weight: 700;

  ${props =>
    props.$index === 0 &&
    css`
      ${props => props.theme.fontFamily.newSpirit};
      ${props => props.theme.typography.heading4};
      margin-bottom: ${props => props.theme.spacing(1)};
      line-height: 1.25;
      font-weight: 500;
      ${NavLinkGroupHeading} {
        margin-top: 0px;
      }
    `}
`;

export const NavigationMenuLink = styled.li`
  color: ${props =>
    props.$fontColor
      ? props.theme.colors.get(props.$fontColor)
      : props.theme.colors.text.lightest};
  list-style: none;
  & button {
    margin: 0;
  }
`;
